import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import Pattern from 'marketing-website/components/commons/Pattern';
import Image from 'marketing-website/components/modules/Image';

import generalStyles from './style/general.module.css';

const bgValues = [
  'marvel',
  'green',
  'teal',
  'yellow',
  'orange',
  'pink',
  'purple',
  'red',
  'white',
];

export default function MediaFeature({
  alt,
  backgroundColor,
  borderRadius,
  children,
  hasShadow,
  pattern,
  patternBottom,
  patternColor,
  patternLeft,
  patternRight,
  patternTop,
  src,
}) {
  const imageClassName = cx(generalStyles.image, {
    [generalStyles.full]: !children,
  });

  const shapeClassname = cx(generalStyles.shape, `bg-${backgroundColor}--xl`);

  const patternProps = {
    color: patternColor,
    type: 'longRectangle',
    size: 'l',
    top: patternTop,
    left: patternLeft,
    right: patternRight,
    bottom: patternBottom,
  };

  return (
    <div className={generalStyles.mediaFeature}>
      <div className={shapeClassname}>
        {pattern && <Pattern {...patternProps} />}
      </div>
      <PageWrap size="l">
        <div className={generalStyles.inner}>
          <div className="position-relative">
            <div className={imageClassName}>
              {src && (
                <Image
                  borderRadius={borderRadius}
                  hasShadow={hasShadow}
                  maxWidth={1300}
                  src={src}
                  alt={alt}
                />
              )}
            </div>
            {children && (
              <div className={generalStyles.features}>{children}</div>
            )}
          </div>
        </div>
      </PageWrap>
    </div>
  );
}

MediaFeature.propTypes = {
  alt: PropTypes.string,
  backgroundColor: PropTypes.oneOf(bgValues),
  borderRadius: PropTypes.string,
  children: PropTypes.node,
  hasShadow: PropTypes.bool,
  pattern: PropTypes.bool,
  patternBottom: PropTypes.string,
  patternColor: PropTypes.string,
  patternLeft: PropTypes.string,
  patternRight: PropTypes.string,
  patternTop: PropTypes.string,
  src: PropTypes.string,
};

MediaFeature.defaultProps = {
  borderRadius: 'l',
  backgroundColor: 'marvel',
  hasShadow: true,
  pattern: true,
  placeholder: 'none',
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaFeature/index.js